
<div>
    <inc-bid-zoom
        v-if      = "zoom"
        :bid      = "bid"
        :data     = "data"
        :status   = "step.status"
        :form     = "form"
        @close    = "zoom = false"
        :readonly = "true"
        style="position: absolute; top: 0; width: 100%"
    />

    <div
        v-if="bid && unit && currentInStep"
        class="abstract-container lm-border pa-3 pr-1 h-100"
        :style="collective ? 'max-height: 512px;' : ''"
    >
        <div class="v-flex w-100">
            <div>
                <div class="abstract-prev-step">2a</div>
                <div class="abstract-prev-bar"></div>
            </div>
            <div class="abstract-panel">
                <inc-abstract-company
                    :manufacturer   = "bid.manufacturer"
                    :execution-date = "currentInStep.executionDate"
                    :deliverytime   = "bid.deliverytime"
                    class="mb-0"
                    :background     = "collective ? 'field-collective' : 'ro-background'"
                />

                <div class="abstract-group mb-0" v-if="bid.number">
                    <inc-calculation-sum
                        class="mb-1"
                        :calculations = "bidUnitData"
                        :navigation   = "true"
                        :collective   = "collective"
                        @navigate     = "onZoom"
                    />
                </div>

                <div class="abstract-group mb-0" v-if="bid.number && collective">
                    <inc-calculation-sum
                        class="mb-0"
                        :calculations = "currentBidUnitData"
                        :navigation   = "true"
                        :collective   = "false"
                        @navigate     = "onZoom"
                    />
                </div>

                <div class="abstract-group mb-0" >
                    <f-title :title="$t('repair.bid.label.measure')" />
                    <div
                        class="abstract-info ro-background"
                        style="min-height: 70px"
                    >
                        {{ bid.calculations[0].notice }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
